import React from 'react';

import NewDashboard from '../components/DashboardNew';
import DashboardLayout from '../layouts/Dashboard/Dashboard';
import {setPageTitle} from '../utils/helpers';
import withFeatureFlags from "../components/FeatureFlags/withFeatureFlags";

const NewDashboardPageContainer = (/** @type {{ notifications?: any[], featureEnabled?: (flag: string) => boolean }} */ { notifications = [], featureEnabled }) => {
  setPageTitle('Dashboard | Investec Save');
  
  return (
    <DashboardLayout notifications={notifications} fullWidth={true}>
      <NewDashboard />
    </DashboardLayout>
  );
};

export default withFeatureFlags(NewDashboardPageContainer);
